module.exports = __webpack_public_path__ + "img/home__1fk3——zh.6030edc6.png";